import React from "react";
import "./SalesForm1.scss";
import CatchDispositionList from "../../components/CatchDispositionList";

const SalesForm1 = (props) => {
  if (props.currentStep !== 1) {
    return null;
  }
  console.group("SalesForm1");
  console.log(props);
  console.groupEnd();
  return (
    <div className="SalesForm1" data-testid="SalesForm1">
      <CatchDispositionList
        trip_id={props.trip_id}
        species={props.species}
        sales={props.sales}
        handleCatchDispositionChange={props.handleCatchDispositionChange}
        combinedSum={props.combinedSales}
      />
    </div>
  );
};

export default SalesForm1;
